import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { nocStatus } from '@/pages/timeline/sections/timeline/timelineSections/noc/constants'
import Tag from '@/components/common/tag/tag'

import RedWarning from "@/assets/icons/redWarning.png";
import { themes } from '@/constants/colors_v2';
import PinkWarning from "@/assets/icons/pinkWarning.png";
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';
import "./style.css"
import GreyInfo from '@/assets/icons/greyInfo.png'

export default function NocIndexView(props: any) {
    const { timeline, common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div className={`flex items-center justify-between nocIndexMain timelineSectionsCommonPaddingLeft ${addCurrentThemeClassToEle(currentTheme, 'nocIndexMain')}`}>
            <div className='flex items-center'>
                <p className='text-[15px] my500px:text-[16px]'>
                    {timeline.submitSection.p1}
                </p>
                <img 
                    onClick={props.handleOpenModal}
                    src={GreyInfo} alt='GreyInfo' className='cursor-pointer ml-[8px] w-[18px]' />

            </div>

            <div className='flex items-center'>
                {props.timelineDetails.nocStatus === nocStatus.rejected &&
                    <Tag
                        text={common.statusText.rejectedText}
                        icon={currentTheme === themes.dark ? PinkWarning : RedWarning}
                        colorCode="red"
                        borderR_tl="5px"
                        borderR_tr="5px"
                        borderR_bl="5px"
                        borderR_br="5px"
                        iconWidth="17px"
                        borderWidth="0.5px"
                        textSize="13px"
                        padding_top="4px"
                        padding_bottom="4px"
                    />
                }
                {props.buttonUI}
            </div>
        </div>
    );
};

